// utilities/webgl.js
let _cachedSupport;
export function hasWorkingWebGL() {
  if (_cachedSupport !== undefined) return _cachedSupport;
  const canvas = document.createElement('canvas');
  const gl = canvas.getContext('webgl', { failIfMajorPerformanceCaveat: true });
  if (!gl) return (_cachedSupport = false);
  const p = new Uint8Array(4);
  gl.clearColor(1, 0, 0, 1);
  gl.clear(gl.COLOR_BUFFER_BIT);
  gl.readPixels(0, 0, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, p);
  return (_cachedSupport = p[0] === 255);
}
